import { axiosHttp } from "../helper/axiosHttp"


export const getProfileService=async()=>{
  
    return await axiosHttp.get('/cuurent-account').then(async(res)=>{
         return res.data
     }).catch((err)=>{
         console.log("error data",err.response);
         return err.response.data;
     });
 }

 
export const updateProfileService=async(data)=>{
   
    return await axiosHttp.post('/profile-update',data).then((res)=>{
          console.log("service log",res.data)
         return  res.data
     }).catch((err)=>{
         console.log("error data",err.response);
         return err.response.data;
     });
 }